<template>
  <div class="kvs-add">
    <Row :gutter="16">
      <i-col span="20">
        <Form ref="newForm" :model="model"
          :rules="modelValidate"
          label-position="right"
          :label-width="160">
          <FormItem label="键" prop="key">
            <Input v-model="model.key"
              placeholder="请输入键" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <RadioGroup v-model="model.type" type="button" button-style="solid">
              <Radio :label="0">文本</Radio>
              <Radio :label="1">JSON</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="值" prop="value">
            <Input v-model="model.value"
              type="textarea"
              :rows="20"
              placeholder="请输入值" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'kvs-add',
  props: {
  },
  data () {
    return {
      loading: false,
      industries: [],
      model: {
        key: null,
        value: null,
        type: 0, // 0-公告|1-公示
      },
      modelValidate: {
        key: [
          { required: true, message: '键不能为空', trigger: 'blur' }
        ]
      },
    }
  },
  watch: {
  },
  mounted () {
    if (!this.checkRolePermitted(['管理员'])) {
      this.$Modal.error({
        title: '错误',
        content: '无权访问该页面',
        onOk: () => {
          this.$router.back()
        }
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: () => {
              this.doSubmit()
            }
          })
        }
      })
    },
    async doSubmit () {
      this.loading = true
      this.$Spin.show()
      let model = Object.assign({}, this.model)
      await Api.KVS.add(model)
        .then((payload) => {
          console.log('suc', payload)
          this.$Message.success('新增成功!')
          this.model= {
            key: null,
            value: null,
            type: 0, // 0-公告|1-公示
          }
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
